import PaymentsSvc from '@efex-services/payments';
import { IApprovePayment } from '@efex-services/payments/types';
import { useApiCall } from '@efexteam/use-api-call';

const useUpdateTransfer = () => {
  const {
    data,
    invoke: updateTransfer,
    loading,
    error,
  } = useApiCall((values?: IApprovePayment) => {
    if (!values) {
      throw new Error('Values are required');
    }
    return PaymentsSvc.approvePayment(values);
  });

  const approveTransfer = (paymentId: string) => {
    updateTransfer({
      payment_id: paymentId,
      is_approve: true,
    });
  };

  const rejectTransfer = (paymentId: string) => {
    updateTransfer({
      payment_id: paymentId,
      is_approve: false,
    });
  };

  return {
    data,
    loading,
    error,
    approveTransfer,
    rejectTransfer,
  };
};

export default useUpdateTransfer;
